module.exports = __webpack_public_path__ + "summary-icon.png?1fa088462cc977f4cd341435ad76e93d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summary-icon.png
// module id = 72
// module chunks = 0